import { pandaSelf, g } from "../const/globalThis";
export var warn = function(msg) {
    var _g___PANDA;
    if (typeof console !== "undefined" && ((_g___PANDA = g.__PANDA) === null || _g___PANDA === void 0 ? void 0 : _g___PANDA.logLevel) >= 2) {
        console.warn("[panda-log] Warn: ".concat(msg));
    }
};
export var error = function(msg) {
    var _g___PANDA;
    if (typeof console !== "undefined" && ((_g___PANDA = g.__PANDA) === null || _g___PANDA === void 0 ? void 0 : _g___PANDA.logLevel) >= 1) {
        console.error("[panda-log] Error: ".concat(msg));
    }
};
export var debugInfo = function(msg) {
    if (typeof console !== "undefined" && pandaSelf.debug) {
        console.error("[panda-log] Debug: ".concat(msg));
    }
};
export var debugError = function(msg) {
    if (typeof console !== "undefined" && pandaSelf.debug) {
        console.error("[panda-log] Error: ".concat(msg));
    }
};
export var isDebugConsole = function() {
    return typeof console !== "undefined" && pandaSelf.debug;
};
